import React from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import Modalstyle from "./modal.module.scss";
import { kpiReport, buttonName } from "../../locales/en";
import InvoiceReportModalTable from "../table/all-tables/reportable/monthlykpireport/modaltabel/invoice/InvoiceReportModalTable";

const MonthlyKpiReportInvoiceModal = ({
  isOpen,
  toggle,
  invoiceIdsListRef,
  filterType
}) => {
  const footerButtons = [
    {
      label: buttonName?.close,
      className: "btn btn-secondary",
      onClick: () => toggle(false)
    }
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={kpiReport?.inVcsModal?.title}
      modalClassName="modal-fullscreen"
      bodyClassName={Modalstyle.refMonthlySingleContent}
      footerButtons={footerButtons}
    >
      <InvoiceReportModalTable
        invoiceIdsListRef={invoiceIdsListRef}
        filterType={filterType}
      />
    </CommonModal>
  );
};

MonthlyKpiReportInvoiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  invoiceIdsListRef: PropTypes.object,
  filterType: PropTypes.string
};

export default MonthlyKpiReportInvoiceModal;
